import _ from "lodash";
import LayoutUtils from "./LayoutUtils";

/** Places every element into the same group **/
class SingleGroupGroupingStrategy {
  constructor(/** Object **/ config = {}) {
    this.config = config;
  }

  apply(/** BlockLayout **/ blockLayout) {
    let elements = blockLayout.elementData;
    let group = null;

    _.each(elements, function (elementData) {
      if (group == null) {
        group = blockLayout.createGroup(elementData.id, elementData);
      } else {
        blockLayout.addElement(group, elementData.id, elementData);
      }
    });
  }
}

export default SingleGroupGroupingStrategy;
